import { Row, Col, Card, Typography } from 'antd';
import { BarChart3, Zap, Shield, Key, Users, Lock, Code } from 'lucide-react';

const { Title, Text } = Typography;

export function Features() {
  const featuresList = [
    {
      icon: BarChart3,
      title: 'Subscription Plans',
      desc: 'Create unlimited pricing tiers',
    },
    {
      icon: Zap,
      title: 'Feature Management',
      desc: 'Enable or disable features per plan',
    },
    {
      icon: Shield,
      title: 'Entitlements Engine',
      desc: 'Control access in real-time',
    },
    {
      icon: Key,
      title: 'API Key Management',
      desc: 'Generate and manage tenant API keys',
    },
    {
      icon: BarChart3,
      title: 'Usage Tracking',
      desc: 'Track requests, quotas, and limits',
    },
    {
      icon: Code,
      title: 'White Label Widgets',
      desc: 'Drop-in pricing and checkout components',
    },
    {
      icon: Users,
      title: 'Multi-Tenant Architecture',
      desc: 'Enterprise-grade isolation',
    },
    {
      icon: Lock,
      title: 'RBAC Security',
      desc: 'Role-based access management',
    },
  ];

  return (
    <section
      id="features"
      style={{
        padding: '80px 24px',
        background: 'linear-gradient(180deg, #ffffff 0%, #f0f5ff 100%)',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <Title
            level={2}
            style={{
              fontSize: 'clamp(24px, 3.5vw, 36px)',
              color: '#1f1f1f',
              margin: 0,
              fontWeight: 700,
            }}
          >
            Everything Needed To Monetize Your Product
          </Title>
        </div>

        <Row gutter={[24, 24]}>
          {featuresList.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <Col xs={24} sm={12} md={8} lg={6} key={index}>
                <Card
                  hoverable
                  className="hover-scale-card"
                  variant="borderless"
                  styles={{
                    body: {
                      padding: '32px 24px',
                      borderRadius: '12px',
                      height: '100%',
                      background: '#ffffff',
                    },
                  }}
                >
                  <div style={{ marginBottom: '20px', color: '#1677ff' }}>
                    <IconComponent size={36} />
                  </div>
                  <Title
                    level={4}
                    style={{
                      fontSize: '18px',
                      margin: '0 0 8px 0',
                      fontWeight: 600,
                      color: '#1f1f1f',
                    }}
                  >
                    {feature.title}
                  </Title>
                  <Text
                    type="secondary"
                    style={{ fontSize: '14px', lineHeight: 1.5 }}
                  >
                    {feature.desc}
                  </Text>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </section>
  );
}
